
namespace TabAurous.Reports {
    import fld = TabAurous.Stock.StockItemRow.Fields;
    @Serenity.Decorators.registerClass()
    export class OwnJewellerySummaryGrid extends Serenity.EntityGrid<TabAurous.Stock.StockItemRow, any> {
        protected getColumnsKey() { return 'Stock.JewelleryReportSummary'; } 
        protected getIdProperty() { return TabAurous.Stock.StockItemRow.idProperty; } 
        protected getLocalTextPrefix() { return TabAurous.Stock.StockItemRow.localTextPrefix; }
        protected getService() { return TabAurous.Stock.OwnJewellerySummaryService.baseUrl; }

        constructor(container: JQuery) {
            super(container); 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 150 });
            this.addDateRangeFilter("VoucherDate", "Date"); 
            this.setTitle("");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid(); 
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            grid.setOptions({ rowHeight: 150 });
            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('Pieces'),
                    new Slick.Aggregators.Sum('Weight'),
                    new Slick.Aggregators.Sum('DiamondPieces'),
                    new Slick.Aggregators.Sum('DiamondWeight'),
                    new Slick.Aggregators.Sum('StonePieces'),
                    new Slick.Aggregators.Sum('StoneWeight'),
                    new Slick.Aggregators.Sum('OtherPieces'),
                    new Slick.Aggregators.Sum('OtherWeight')]
            });
             
            //this.view.setGrouping([{
            //    formatter: g => {
            //        return "<span class='slick-group-title-header'>" +
            //            g.value +
            //            "<span class='slick-cell l7 r7'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.Pieces + "</span></span>" +
            //            "<span class='slick-cell l8 r8'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.Weight.toFixed(3) + "</span></span>";
            //    },
            //    getter: 'ProductCode',
            //    displayTotalsRow: false,
            //}])

            return grid;
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: Serenity.LookupEditor,
                options: {

                    lookupKey: "AllProducts",
                    multiple: true

                },
                field: 'ProductId',
                title: 'Product',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).ProductIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                },

                cssClass: 'hidden-xs'
            });


            return filters;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            opt.rowHeight = 150;
            return opt;
        }
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            buttons.push({
                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {
                    Q.postToService({
                        service: TabAurous.Stock.OwnJewellerySummaryService.baseUrl + '/ExportExcelWithoutImages',
                        request: {
                            Items: this.view.getItems(),
                        },

                        target: '_blank'
                    });
                }
            }
            );
            buttons.push({
                title: 'Print with Images',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {
                    Q.postToService({
                        service: TabAurous.Stock.OwnJewellerySummaryService.baseUrl + '/ExportExcelWithImages',
                        request: {
                            Items: this.view.getItems(),
                        },

                        target: '_blank'
                    });
                }
            }
            );
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                reportTitle: "Own Jewellery Summary"
            }));

            return buttons;
        }
    }
}